import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { EventService } from '../../services/event.service';
import { MessageService } from '../../services/message.service';
import { Message } from '../../models/message';

@Component({
  selector: 'app-message-bar',
  templateUrl: './message-bar.component.html',
  styleUrls: ['./message-bar.component.scss']
})
export class MessageBarComponent implements OnInit, OnDestroy {

  private messagesChangedSubscription: Subscription;

  constructor(
    private events: EventService,
    private messageService: MessageService,
    private changeDetectorRef: ChangeDetectorRef,
  ) {
  }

  ngOnInit(): void {
    this.messagesChangedSubscription = this.events.messagesChanged.subscribe(() => {
      this.changeDetectorRef.detectChanges();
    });
  }

  ngOnDestroy(): void {
    this.messagesChangedSubscription.unsubscribe();
  }

  public get hasMessages(): boolean {
    return this.messageService.hasMessages;
  }

  /**
   * Returns messages belonging to all message kinds
   */
  public get messages(): Message[] {
    return this.messageService.all;
  }

  public get messageToBeShown(): Message {
    return this.messages[ this.messages.length - 1 ];
  }
}
